import { EVIDENCE_TYPE_KH, EVIDENCE_TYPE_KPIR, EVIDENCE_TYPE_RYCZALT } from '../../../constants/evidence.js';
import column from '../../abstract/column';
import vars from '../../abstract/vars';
import actions from './actions';
import api from './api';

const getBossCompany = ($store) => $store.getters['auth/getActiveBossCompany'];
const getFormOfAccounting = ($store) => getBossCompany($store)?.form_of_accounting?.id;
const showVatRate = ({ $store }) => getBossCompany($store).vat_payer;
const showKpir = ({ $store }) => getFormOfAccounting($store) === EVIDENCE_TYPE_KPIR;
const showRyczalt = ({ $store }) => getFormOfAccounting($store) === EVIDENCE_TYPE_RYCZALT;
const showKH = ({ $store }) => getFormOfAccounting($store) === EVIDENCE_TYPE_KH;

export default {
  actions,
  api,
  topRightActions: {
    create: {
      label: 'Dodaj dokument',
      icon: 'icon-plus',
      handle: async ({ $router }) => await $router.push('/admin/templates/invoice-descriptions/add'),
    },
  },
  sidebarData: {
    id: column({
      label: 'Identyfikator',
      size: 100
    }),
  },
  columns: {
    description: column({
      label: 'Opis',
    }),
    vat_rate: column({
      label: 'Stawka VAT',
      grid: showVatRate,
      sidebar: showVatRate,
    }),
    pkwiu: column({
      label: 'PKWiU',
    }),
    unit: column({
      label: 'Jednostka',
    }),
    kpir: column({
      label: 'Kolumna KPiR',
      grid: showKpir,
      sidebar: showKpir,
    }),
    ryczalt: column({
      label: 'Stawka ryczałtu',
      grid: showRyczalt,
      sidebar: showRyczalt,
    }),
    ledger_account: column({
      label: 'Konto księgowe',
      grid: showKH,
      sidebar: showKH,
    }),
    vat_register: column({
      label: 'Rejestr VAT',
    }),
    gtu: column({
      label: 'GTU',
    }),
  },
  vars: vars({
    noItemsText: () => 'Brak szablonów',
    sidebarLabel: () => 'Podgląd szablonu',
    mainTabLabel: 'Szablon',
    softDelete: {
      title: 'Usunięcie szablonu',
      text: ({ template }) => `Czy na pewno chcesz usunąć szablon o id ${ template.id }?`,
      successText: 'Szablon został usunięty.',
    },
    onSuccessSave: async ({ $router }) => {
      await $router.push({
        path: '/admin/templates/invoice-descriptions',
      });
    },
  }),
};
